var render = function render(){var _vm=this,_c=_vm._self._c;return _c('u-popover',{class:_vm.v2 ? 'window-context-menu-v2' : 'window-context-menu menu-profile min',attrs:{"anchor":"bottom right","self":"top right"}},[_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }